var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-box"},[_vm._m(0),_c('div',{staticClass:"content"},_vm._l((_vm.options.insuranceHistory),function(item,index){return _c('div',{key:index},[_c('div',[_vm._v(_vm._s(item.year || '--'))]),_c('div',[_vm._v(_vm._s(item.premium || '--'))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headline"},[_c('div',[_vm._v("年份")]),_c('div',[_vm._v("保费")])])
}]

export { render, staticRenderFns }